import Action from '../Action';

const initialState = {
	counts: [],
};

export default (state = initialState, action) => {
	switch (action.type) {
		case Action.TOTAL_COUNT:
			return { ...state, counts: action.counts };
		case Action.SELECT_DATE:
			return { ...state, date: action.date };
		default:
			return state;
	}
};
